import { ref } from 'vue';

export function useActiveTimeTracker(idleTimeout = 10000) {
  const activeTime = ref(0);
  let isActive = false;
  let lastInteraction = 0;
  let timer = null;

  const interactionEvents = ['click', 'scroll', 'keydown', 'mousemove', 'touchstart'];

  const onUserInteraction = () => {
    lastInteraction = Date.now();
    if (!isActive) startTimer();
  };

  const resetActiveTime = () => {
    activeTime.value = 0;
    lastInteraction = Date.now();
  };

  const startTimer = () => {
    isActive = true;
    timer = setInterval(() => {
      if (Date.now() - lastInteraction > idleTimeout) {
        stopTimer();
        return;
      }
      activeTime.value++;
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(timer);
    timer = null;
    isActive = false;
  };

  const startTracking = () => {
    interactionEvents.forEach((evt) => window.addEventListener(evt, onUserInteraction, { passive: true }));
    lastInteraction = Date.now();
  };

  const stopTracking = () => {
    stopTimer();
    interactionEvents.forEach((evt) => window.removeEventListener(evt, onUserInteraction));
  };

  return { startTracking, stopTracking, activeTime, resetActiveTime };
}
